import { render, staticRenderFns } from "./ProductNew.vue?vue&type=template&id=5a329edd&scoped=true&"
import script from "./ProductNew.vue?vue&type=script&lang=js&"
export * from "./ProductNew.vue?vue&type=script&lang=js&"
import style0 from "./ProductNew.vue?vue&type=style&index=0&id=5a329edd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a329edd",
  null
  
)

export default component.exports